export default __webpack_public_path__ + "static/media/champselect-logo.30fdac7f.svg";